/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostDestinationTestEventPathParams = NonNullable<
  operations['postDestinationTestEvent']['parameters']['path']
>;

export interface Input extends PostDestinationTestEventPathParams {
  apiVersion?: string;
}

export async function postDestinationTestEvent(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/destinations/{projectKey}/{environmentKey}/{id}/test-event', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
